import React from 'react';
import { CardContent } from '@/components/ui/card';

export interface ErpCardBodyProps {
  className?: string;
  children?: React.ReactNode;
}
const ErpCardBody: React.FC<ErpCardBodyProps> = ({ className, children, ...props }) => (
  <CardContent className={className} {...props}>{children}</CardContent>
);
export default ErpCardBody;
